import { buildUrl, handleResponse } from "./auth";

const jsonHeaders = { "Content-Type": "application/json" };

const buildQuery = (params = {}) => {
  const parts = Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && value !== "")
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(
          value instanceof Date ? value.toISOString() : value
        )}`
    );
  return parts.length ? `?${parts.join("&")}` : "";
};

export const getAdminBookings = (params) =>
  fetch(buildUrl(`/api/admin/bookings${buildQuery(params)}`), {
    credentials: "include",
  }).then(handleResponse);

export const getAdminBooking = (bookingId) =>
  fetch(buildUrl(`/api/admin/bookings/${bookingId}`), {
    credentials: "include",
  }).then(handleResponse);

export const updateAdminBooking = (bookingId, payload) =>
  fetch(buildUrl(`/api/admin/bookings/${bookingId}`), {
    method: "PATCH",
    headers: jsonHeaders,
    body: JSON.stringify(payload ?? {}),
    credentials: "include",
  }).then(handleResponse);

export const updateAdminBookingStatus = (bookingId, payload) =>
  fetch(buildUrl(`/api/admin/bookings/${bookingId}/status`), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload ?? {}),
    credentials: "include",
  }).then(handleResponse);

export const refundAdminBooking = (bookingId, payload) =>
  fetch(buildUrl(`/api/admin/bookings/${bookingId}/refund`), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload ?? {}),
    credentials: "include",
  }).then(handleResponse);

export const resendAdminBookingToken = (bookingId) =>
  fetch(buildUrl(`/api/admin/bookings/${bookingId}/token/resend`), {
    method: "POST",
    credentials: "include",
  }).then(handleResponse);

export const revokeAdminBookingToken = (bookingId, payload) =>
  fetch(buildUrl(`/api/admin/bookings/${bookingId}/token/revoke`), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload ?? {}),
    credentials: "include",
  }).then(handleResponse);

const adminBookingsApi = {
  getAdminBookings,
  getAdminBooking,
  updateAdminBooking,
  updateAdminBookingStatus,
  refundAdminBooking,
  resendAdminBookingToken,
  revokeAdminBookingToken,
};

export default adminBookingsApi;
